import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/Login.vue'
import Regist from '../components/Regist.vue'
import Map from '../components/main/Map.vue'
import store from '@/store'
import { Message } from 'element-ui'
import Edit from '../components/Edit.vue'

Vue.use(Router)

var router = new Router({
  routes: [
    {
      path: '/map',
      name: 'map',
      component: Map,
      meta: {
        requiresAuth: true
      }
    },
    {
      path:'/',
      component:Login,
      name:'index',
      meta:{
        requiresAuth:false
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/regist',
      name: 'regist',
      component: Regist,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/edit',
      name: 'edit',
      component: Edit,
      props:true,
      meta: {
        requiresAuth: false
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = checkAuth(); // 检查用户是否登录
  if (to.meta.requiresAuth && !isAuthenticated) {
    // 如果目标路由需要登录且用户未登录，跳转到登录页
    Message.error('请先登陆...')
    next('/login');
  } else {
    // 否则继续导航
    next();
  }
})

function checkAuth() {
  let user = store.state.user
  if (user) {
    return true
  } else
    return false
}


export default router



// WEBPACK FOOTER //
// ./src/router/index.js